import intervendQueueService from "../../../apis/services/admin/intervendQueueService";
import {
  FETCH_QUEUE_METRICS_ATTEMPT,
  FETCH_QUEUE_METRICS_SUCCESS,
  FETCH_QUEUE_METRICS_ERROR,
  FETCH_QUEUE_SUMMARY_ATTEMPT,
  FETCH_QUEUE_SUMMARY_SUCCESS,
  FETCH_QUEUE_SUMMARY_ERROR,
  FETCH_QUEUE_JOBS_ATTEMPT,
  FETCH_QUEUE_JOBS_SUCCESS,
  FETCH_QUEUE_JOBS_ERROR,
  TRUNCATE_QUEUE_ATTEMPT,
  TRUNCATE_QUEUE_SUCCESS,
  TRUNCATE_QUEUE_ERROR,
  TRUNCATE_QUEUE_RESET_STATE,
} from "../../actionTypes/actionTypes";

export const fetchQueueMetrics = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_QUEUE_METRICS_ATTEMPT });
    try {
      const response = await intervendQueueService.getQueueMetrics();
      dispatch({
        type: FETCH_QUEUE_METRICS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_QUEUE_METRICS_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchQueueSummary = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_QUEUE_SUMMARY_ATTEMPT });
    try {
      const response = await intervendQueueService.getQueueSummary();
      dispatch({
        type: FETCH_QUEUE_SUMMARY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_QUEUE_SUMMARY_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchQueueJobs = (state = "waiting", page = 1, perPage = 20) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_QUEUE_JOBS_ATTEMPT });
    try {
      const response = await intervendQueueService.getQueueJobs(state, page, perPage);
      dispatch({
        type: FETCH_QUEUE_JOBS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_QUEUE_JOBS_ERROR,
        payload: error,
      });
    }
  };
};

export const truncateQueue = (state = "all") => {
  return async (dispatch) => {
    dispatch({ type: TRUNCATE_QUEUE_ATTEMPT });
    try {
      const response = await intervendQueueService.truncateQueue(state);
      dispatch({
        type: TRUNCATE_QUEUE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: TRUNCATE_QUEUE_ERROR,
        payload: error,
      });
    }
  };
};

export const truncateQueueResetState = () => {
  return (dispatch) => {
    dispatch({ type: TRUNCATE_QUEUE_RESET_STATE });
  };
};

